import React from "react";

type Props = {
  size?: number;
  color?: string;
  className?: string;
};

const IconType: React.FC<Props> = ({
  size = 32,
  color = "#3E3851",
  className = "fill-neutral-60",
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
      className={className}
    >
      <path
        d="M4.42443 17.0829C4.00345 17.0829 3.64714 16.937 3.35547 16.6454C3.0638 16.3537 2.91797 15.9974 2.91797 15.5764V4.42266C2.91797 4.00168 3.0638 3.64536 3.35547 3.3537C3.64714 3.06203 4.00345 2.9162 4.42443 2.9162H10.1344C10.3428 2.9162 10.499 2.98161 10.6032 3.11245C10.7073 3.24342 10.7594 3.38634 10.7594 3.5412C10.7594 3.69606 10.7052 3.83898 10.5967 3.96995C10.4882 4.10078 10.3298 4.1662 10.1215 4.1662H4.42443C4.36026 4.1662 4.30151 4.19293 4.24818 4.24641C4.19471 4.29974 4.16797 4.35849 4.16797 4.42266V15.5764C4.16797 15.6406 4.19471 15.6993 4.24818 15.7527C4.30151 15.8061 4.36026 15.8329 4.42443 15.8329H15.5782C15.6423 15.8329 15.7011 15.8061 15.7544 15.7527C15.8079 15.6993 15.8346 15.6406 15.8346 15.5764V9.82641C15.8346 9.61807 15.9001 9.46182 16.0309 9.35766C16.1619 9.25349 16.3048 9.20141 16.4596 9.20141C16.6145 9.20141 16.7574 9.25349 16.8884 9.35766C17.0192 9.46182 17.0846 9.61807 17.0846 9.82641V15.5764C17.0846 15.9974 16.9388 16.3537 16.6471 16.6454C16.3555 16.937 15.9991 17.0829 15.5782 17.0829H4.42443ZM7.91797 11.3295V9.84578C7.91797 9.64481 7.957 9.45168 8.03505 9.26641C8.11297 9.08099 8.22033 8.91995 8.35714 8.78328L15.4678 1.67266C15.5969 1.54335 15.739 1.44904 15.894 1.38974C16.0489 1.33043 16.2064 1.30078 16.3667 1.30078C16.5302 1.30078 16.6872 1.33043 16.8378 1.38974C16.9885 1.44904 17.1257 1.54064 17.2496 1.66453L18.2961 2.70786C18.4168 2.83717 18.5095 2.97981 18.5742 3.13578C18.6388 3.29175 18.6711 3.44988 18.6711 3.61016C18.6711 3.77043 18.6436 3.92585 18.5886 4.07641C18.5336 4.2271 18.4414 4.36703 18.3121 4.4962L11.1776 11.631C11.0407 11.7677 10.8797 11.8772 10.6944 11.9595C10.509 12.0418 10.3159 12.0829 10.1151 12.0829H8.6713C8.45644 12.0829 8.2772 12.011 8.13359 11.8672C7.98984 11.7236 7.91797 11.5444 7.91797 11.3295ZM9.16797 10.8329H10.2065L15.4003 5.63891L14.8811 5.11974L14.3251 4.58453L9.16797 9.74161V10.8329Z"
        fill={color}
      />
    </svg>
  );
};

export default IconType;
